module.exports = __webpack_public_path__ + "static/media/Star_is_Born_Spoof.f316e74b.png";